import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';
import { PriceSchedule } from 'src/shared/models/price-schedule.model';

/**
 * We are adding this validator so we can compare the current name in the form with the names saved for other price schedules in the scope
 * of an item variation. It considers the price_schedule_id to avoid flagging the current name as a duplicate of itself when editing an
 * existing price schedule.
 */
export function savedNamesUniquenessValidator(
  savedSchedules: Partial<PriceSchedule>[],
  currentId?: number
): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const currentName = control.value?.trim();
    if (!currentName) {
      return null;
    }

    const duplicate = savedSchedules.some(
      schedule =>
        schedule.price_schedule_id !== currentId &&
        schedule.pricing_name?.trim().toLowerCase() === currentName.toLowerCase()
    );

    return duplicate ? { savedNameNotUnique: true } : null;
  };
}
